<div class="overlay-wrapper" *ngIf="isLoading">
    <p-progressSpinner></p-progressSpinner>
</div>

<main id="content" role="main" class="main">

    <div class="content container">
    <div >
    <nav aria-label="breadcrumb"><ol id="w0" class="breadcrumb"><li class="breadcrumb-item"><a href="/">{{'home'|translate}}</a></li>
    <li class="breadcrumb-item active" aria-current="page">{{'profile'|translate}}</li>
    </ol></nav> </div>
    <div class="row justify-content-lg-center" >
    <div class="col-lg-10">
    
    <div class="profile-cover">
    <div class="profile-cover-img-wrapper">
    <img id="profileCoverImg" class="profile-cover-img" src="../../../assets/images/profileBackground.jpg" alt="Image Description">
    </div>
    </div>
    
    
    <div class="text-center">
    
    <label class="avatar avatar-xxl avatar-circle avatar-uploader profile-cover-avatar" for="editAvatarUploaderModal">
    <img id="editAvatarImgModal" class="avatar-img" src="../../../assets/images/user.jpg" alt="Image Description">
    </label>
    
    <h1 class="page-header-title">
        {{getUserName }}    
    <i class="bi-patch-check-fill fs-2 text-primary"></i></h1>
    </div>
    
    
    <div class="js-nav-scroller hs-nav-scroller-horizontal mb-5">
    <span class="hs-nav-scroller-arrow-prev" style="display: none;">
    <a class="hs-nav-scroller-arrow-link" href="javascript:;">
    <i class="bi-chevron-left"></i>
    </a>
    </span>
    <span class="hs-nav-scroller-arrow-next" style="display: none;">
    <a class="hs-nav-scroller-arrow-link" href="javascript:;">
    <i class="bi-chevron-right"></i>
    </a>
    </span>
    <ul class="nav nav-tabs align-items-center">
     <li class="nav-item d-none d-sm-block">
    <a class="nav-link active disabled" href="#">{{'personalInfo'|translate}}</a>
    </li>
    <li class="nav-item me-auto">
    <div class="d-flex gap-2" *ngIf="loginBy=='Govnet'">
        <a class="btn btn-white" (click)="showChagePhoneDialog=true">
            <i class="bi-at me-1"></i> تغيير رقم الهاتف
        </a> 
        <a class="btn btn-white" (click)="showChageEmailDialog=true" >
            <i class="bi-pencil-square me-1"></i> تغيير البريد الالكتروني
        </a> 
    </div>
    </li>
    </ul>
    </div>
    
    <div class="row">
    <div class="col-lg-12">
    
    <div class="card mb-3 mb-lg-5">
    
    <div class="card-body">
    <div class="row">
    <div class="col-md-6">
    <ul class="list-unstyled list-py-2 text-dark mb-0 fs-3">
    <li class="pb-0"><span class="card-subtitle">{{'basicInfo'|translate}}</span></li>
    <li><i class="bi-person dropdown-item-icon"></i>
        {{getUserName}}    
    </li>
    <li><i class="bi-briefcase dropdown-item-icon"></i> 
        {{userInfo?.userName ?? personalInfo?.nationalID}}    
    </li>
    <li><i class="bi-building dropdown-item-icon"></i> {{nationality}} </li>
    </ul>
    </div>
    <div class="col-md-6" *ngIf="loginBy=='Govnet'">
    <ul class="list-unstyled list-py-2 text-dark mb-0 fs-3">
    <li class="pt-4 pb-0"><span class="card-subtitle">{{'contactInfo'|translate}}</span></li>
    <li><i class="bi-at dropdown-item-icon"></i> 
        {{userInfo?.email}}   
    </li>
    <li><i class="bi-phone dropdown-item-icon"></i> 
        {{userInfo?.phoneNumber}}   
    </li>
    </ul>
    </div>
    </div>
    </div>
    
    </div>
    
    </div>
    
    </div>
    
    </div>
    
    </div>
    </div>
    
    </main>


<p-dialog header="تغيير البريد الالكتروني" [(visible)]="showChageEmailDialog" [modal]="true" [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false">
    <p class="m-0">
        البريد الالكتروني
    </p>

    <div class="row justify-content-center">
        <div class="col-md-6 text-center">
            <input type="email" name="email" [(ngModel)]="email" class="form-control" id="email">

            <button class="btn btn-primary my-3" [disabled]="email==undefined || email==''" (click)="sendOtpEmail()">
                ارسال
            </button>
        </div>
    </div>
</p-dialog>

<p-dialog header="تغيير رقم الهاتف" [(visible)]="showChagePhoneDialog" [modal]="true" [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false">
    <p class="m-0">
        رقم الهاتف
    </p>

    <div class="row justify-content-center">
        <div class="col-md-6 text-center">
            <div class="col-sm-12 mb-4 wrapper" style="direction: ltr;">
                <ngx-intl-tel-input
                      [cssClass]="'form-control form-control-lg input-country-code'"
                      [preferredCountries]="preferredCountries"
                      [enableAutoCountrySelect]="true"
                      [enablePlaceholder]="false"
                      [searchCountryFlag]="true"
                      [searchCountryField]="[
                        SearchCountryField.Iso2,
                        SearchCountryField.Name
                      ]"
                      [selectFirstCountry]="true"
                      [selectedCountryISO]="CountryISO.Jordan"
                      [phoneValidation]="false"
                      [separateDialCode]="separateDialCode"
                      [numberFormat]="PhoneNumberFormat.National"
                      name="phone"
                      [(ngModel)]="phone"
                      [required]="true"
                    >

                    </ngx-intl-tel-input>
                  
            </div>

            <button class="btn btn-primary my-3" [disabled]="phone==undefined || phone==''" (click)="sendOtpPhone()">
                ارسال
            </button>
        </div>
    </div>
</p-dialog>


<p-dialog [(visible)]="showOtpDialog" [modal]="true" [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false">
    <p class="m-0">
       رمز التحقق
    </p>

    <div class="row justify-content-center">
        <div class="col-md-6 text-center">
            <input type="text" name="otp" [(ngModel)]="otp" class="form-control" id="otp">

            <button class="btn btn-primary my-3" [disabled]="otp==undefined" (click)="sendOtp()">
                ارسال
            </button>
        </div>
    </div>
</p-dialog>